
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dispensary/getstarted",
      function () {
        return require("private-next-pages/dispensary/getstarted.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dispensary/getstarted"])
      });
    }
  